function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function() {
    var self = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
import axios from "axios";
function browserFetch(requestConfig) {
  return _browserFetch.apply(this, arguments);
}
function _browserFetch() {
  _browserFetch = _async_to_generator(function* (requestConfig) {
    const { rawResponse = false } = requestConfig, axiosConfig = _object_without_properties(requestConfig, [
      "rawResponse"
    ]);
    const defaultOptions = {
      url: "",
      method: "GET",
      params: {},
      config: {
        timeout: 6e4
      }
    };
    const mergedConfig = _object_spread({}, defaultOptions, axiosConfig);
    try {
      const response = yield axios(mergedConfig);
      if (rawResponse) {
        return response;
      }
      var _response_data_statusCode, _ref;
      const status = (_ref = (_response_data_statusCode = response.data.statusCode) !== null && _response_data_statusCode !== void 0 ? _response_data_statusCode : response.data.code) !== null && _ref !== void 0 ? _ref : response.data.status;
      if (status === 0 || status === 200) {
        return response.data.body;
      }
      throw new Error(`web-privacy-sdk fetch error response=${JSON.stringify(response)}`);
    } catch (error) {
      if (axios.isCancel(error)) {
        return null;
      } else {
        throw error;
      }
    }
  });
  return _browserFetch.apply(this, arguments);
}
export {
  browserFetch
};
